import React from "react";
import { DarkTheme, DefaultTheme, NavigationContainer, CommonActions} from '@react-navigation/native';
import {createStackNavigator} from "@react-navigation/stack";
import {connect} from "react-redux";
import {AppState, Image, StatusBar, StyleSheet, Text, View} from "react-native";
import ConnexionScreen from "../Component/Screens/ConnexionScreen";
import NIPScreen from "../Component/Screens/NIPScreen";
import UpdateScreen from "../Component/Screens/UpdateScreen";
import MyTheme from "../Theme/Theme";
import FeedScreen from "../Component/Screens/FeedScreen";
import Logo from "../Component/Picto/Logo";
import AvatarIcon from "../Component/Header/AvatarIcon";
import PostScreen from "../Component/Screens/PostScreen";
import {createBottomTabNavigator} from "@react-navigation/bottom-tabs";
import FooterAccueilPicto from "../Component/Picto/FooterAccueilPicto";
import FooterTendancePicto from "../Component/Picto/FooterTendancePicto";
import FooterRecherchePicto from "../Component/Picto/FooterRecherchePicto";
import FooterMessagePicto from "../Component/Picto/FooterMessagePicto";
import FooterAccueilActivePicto from "../Component/Picto/FooterAccueilActivePicto";
import FooterTendanceActivePicto from "../Component/Picto/FooterTendanceActivePicto";
import FooterRechercheActivePicto from "../Component/Picto/FooterRechercheActivePicto";
import FooterMessageActivePicto from "../Component/Picto/FooterMessageActivePicto";
import TendanceScreen from "../Component/Screens/TendanceScreen";
import FiltrePicto from "../Component/Picto/FiltrePicto";
import TendanceFeedScreen from "../Component/Screens/TendanceFeedScreen";
import HeaderTitreSousTitre from "../Component/Header/HeaderTitreSousTitre";
import ExplorerScreen from "../Component/Screens/ExplorerScreen";
import ProfilScreen from "../Component/Screens/ProfilScreen";
import * as Linking from "expo-linking";
import ModifierPicto from "../Component/Picto/ModifierPicto";
import FocusScreen from "../Component/Screens/FocusScreen";
import EntityScreen from "../Component/Screens/EntityScreen";
import ReglageScreen from "../Component/Screens/ReglageScreen";
import ReglageApparenceScreen from "../Component/Screens/ReglageApparenceScreen";
import ReglageLangScreen from "../Component/Screens/ReglageLangScreen";
import ReglageConfidentialiteScreen from "../Component/Screens/ReglageConfidentialiteScreen";
import ReglageCacheScreen from "../Component/Screens/ReglageCacheScreen";
import ReglageNotifScreen from "../Component/Screens/ReglageNotifScreen";
import ReglageCGU from "../Component/Screens/ReglageCGU";
import BookmarkScreen from "../Component/Screens/BookmarkScreen";
import EditProfilScreen from "../Component/Screens/EditProfilScreen";
import MessengerScreen, {importConverseJS} from "../Component/Screens/MessengerScreen";
import { throttle } from "../utils/func";

import { updateFound, swRegistrationUpdate, getSwRegistration } from "../sw/sw_registration";
import { ensureSubscribe } from "../sw/sw_subscribe";


const StackNavigator = createStackNavigator();
const Tab = createBottomTabNavigator();
import "../lang/i18n";
import WebviewScreen from "../Component/Screens/WebviewScreen";
import UserInactivity from "react-native-user-inactivity";
import moment from "moment";


const getNavigationContainerOpt = (props) => {
  return {
    documentTitle: { enabled: false },
    theme: props.isDark ? DarkTheme : DefaultTheme
  }
}


// Watch inactivity. Above a threshold, call the callback
function setupLastSeen(onExpire) {
  const minutes_max_before_pin_out = 15;

  // init at load
  let last_seen = localStorage.getItem("lastseen") || moment().format('YYYY-MM-DD HH:mm:ss');

  // TESTING PURPOSE
  window.onExpire = onExpire;

  function checkLastSeen() {
    const now = moment();

    if (now.diff(last_seen, 'minute') >= minutes_max_before_pin_out) {
      onExpire()
    }

    last_seen = now.format('YYYY-MM-DD HH:mm:ss');
    localStorage.setItem("lastseen", last_seen);
  }

  // throttle for 15 seconds
  const throttledCheck = throttle(checkLastSeen, 1000 * 15);

  const events = ['focus', 'mousemove', 'touchstart', 'keypress'];

  events.forEach(e => {
    window.addEventListener(e, throttledCheck)
  })
}


class NavigationStack extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            appState: AppState.currentState,
	    swUpdate: null
            // initialized: false,
        }
        this._getHomeStackNavigator = this._getHomeStackNavigator.bind(this);
        this._getTendanceStackNavigator = this._getTendanceStackNavigator.bind(this);
        this._getExplorerStackNavigator = this._getExplorerStackNavigator.bind(this);
        this.checkBodyNotificationClass = this.checkBodyNotificationClass.bind(this);
	this._handleAppStateChange = this._handleAppStateChange.bind(this);

	/*
        const setInit = () => {
          this.setState({ initialized: true })
        }

        this.props.initPromise.then(setInit).catch(setInit);
	*/
    }

    componentDidMount() {
       AppState.addEventListener("change", this._handleAppStateChange);

        if ( this.props.auth.compte != null && this.props.tokenNIP != null) {
            //const action = {'type': 'SIGN_OUT_NIP', 'value':{}};
            //this.props.dispatch(action);
        }

        const observer = new MutationObserver(this.checkBodyNotificationClass);
        observer.observe(document.body,{attributes:true,attributeOldValue:true});

        false && setupLastSeen(() => {
          const action = {'type': 'SIGN_OUT_NIP', 'value':{}};
          this.props.dispatch(action);
        })
    }

    checkBodyNotificationClass(mutationList){
        for(let mutation of mutationList){
            if(mutation.attributeName === 'class'){
                const notification = mutation.target.classList.contains('notification');
                const numUnread = mutation.target.getAttribute('notification');
                const action = {'type': 'SET_NOTIFICATION', 'value':{'notification' : notification,'numUnread' : numUnread}};
                this.props.dispatch(action);
            }
        }
    }

    componentWillUnmount() {
       AppState.removeEventListener("change", this._handleAppStateChange);
    }

    wrap(Component) {
      // check and intercept by setting
      const check = () => {
	console.log("[FeedScreen] mounting and checking");

	// reloading when no controller found will loop /!\
	// if (!navigator.serviceWorker?.controller || updateFound()) {
	if (updateFound()) {
	  console.log("[NAV] updateFound");
	  // this will trigger a whole new update
	  // return this.setState({swUpdate});
	  // reload to /app which is not cached contrary to /app/home?!

	  location.href = "/app";
	}
      }

      return (props) => {
	check()

	return <Component {...props} />
      }
    }

    _getHomeStackNavigator(){
        return (
            <StackNavigator.Navigator>
                <StackNavigator.Screen name={"Home"}  component={this.wrap(FeedScreen)}/>
                <StackNavigator.Screen name={"MyProfil"}  options={{headerShown:false}} component={ProfilScreen}/>
                <StackNavigator.Screen name={"PostFeed"}  component={PostScreen}/>
                <StackNavigator.Screen name={"MyFocus"} component={FocusScreen}/>
                <StackNavigator.Screen name={"Bookmark"} component={BookmarkScreen}/>
                <StackNavigator.Screen name={"EntityScreen"} getId={({params})=>{return params.type+'-'+params.id}} component={EntityScreen}/>
                <StackNavigator.Screen name={"Reglage"} component={ReglageScreen}/>
                <StackNavigator.Screen name={"editProfil"}  component={EditProfilScreen}/>
                <StackNavigator.Screen name={"Apparence"} component={ReglageApparenceScreen}/>
                <StackNavigator.Screen name={"Langue"}  component={ReglageLangScreen}/>
                <StackNavigator.Screen name={"Confidentialite"}  component={ReglageConfidentialiteScreen}/>
                <StackNavigator.Screen name={"SWCache"}  component={ReglageCacheScreen}/>
                <StackNavigator.Screen name={"SWNotif"}  component={ReglageNotifScreen}/>
                <StackNavigator.Screen name={"CGU"}  component={ReglageCGU}/>
                <StackNavigator.Screen name={"NIP"} options={{  tabBarVisible:false, headerShown: false}} component={NIPScreen}/>
                <StackNavigator.Screen name={"Connexion"} options={{  tabBarVisible:false, headerShown: false}}  component={ConnexionScreen}/>
                <StackNavigator.Screen name={"WebView"} component={WebviewScreen}/>
                <StackNavigator.Screen name={"Message"} component={MessengerScreen}/>
            </StackNavigator.Navigator>);
    }

    _getTendanceStackNavigator(){
        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            elevation: 0,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;

        const headerLogoCompteOption = ({navigation})=> {
            return {
                headerTitle: () => (<Logo />),
                headerStyle:styleHeaderGlobal,
                headerTitleAlign:"center",
                headerLeft:(props)=>(<AvatarIcon style={{width:38,height:38}} isHeader={true} icon={this.props.auth.compte.img}/>),
                headerRight:(props)=>(<FiltrePicto style={{width:20,height:17,flex : 1,marginRight:20 } } isHeader={true} />),
                cardStyle: {backgroundColor : this.props.theme.colors.tertiary.grey3.value}
            }
        }

        const headerTitreSousTitre = ({navigation})=> {
            return {
                headerTitle: (props) => (<HeaderTitreSousTitre navigation={navigation} p={props}/>),
                headerStyle:styleHeaderGlobal,
                headerTitleAlign:"center",
                headerBackImage: ()=>(<Image resizeMode={"contain"} style={{width:20,height: 20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />)
            }
        }
        const headerTitreBackModifier = ({navigation})=> {
            return {
                headerTitleAlign: "center",
                headerTitle:"Mes focus",
                headerRight:(props)=>(<ModifierPicto style={{width:20,flex : 1,height:"100%",marginRight:20 } } isHeader={true} />),
                //headerBackImage : this.props.theme.pictos.chevronGaucheMediumPicto,
                headerBackImage: ()=>(<Image resizeMode={"contain"} style={{width:20,height: 20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />)
            }
        };

        const headerTitreBack = ({navigation})=> {
            return {
                headerTitleAlign: "center",
                headerTitle:"Mes focus",
                headerRight:(props)=>(<ModifierPicto style={{width:20,flex : 1,height:"100%",marginRight:20 } } isHeader={true} />),
                //headerBackImage : this.props.theme.pictos.chevronGaucheMediumPicto,
                headerBackImage: ()=>(<Image resizeMode={"contain"} style={{width:20,height: 20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />)
            }
        };

        return (
            <StackNavigator.Navigator>
                <StackNavigator.Screen name={"tendance"} component={TendanceScreen}/>
                <StackNavigator.Screen name={"MyProfil"}  options={{headerShown:false}} component={ProfilScreen}/>
                <StackNavigator.Screen name={"PostFeed"} getId={({params})=>{params.postId}} component={PostScreen}/>
                <StackNavigator.Screen name={"TendancePostFeed"} options={(routes)=>({...headerTitreSousTitre(routes),headerStyle : styleHeaderGlobal})} component={TendanceFeedScreen}/>
                <StackNavigator.Screen name={"EntityScreen"} getId={({params})=>{return params.type+'-'+params.id}} options={{...headerTitreBackModifier({}),headerStyle : styleHeaderGlobal}} component={EntityScreen}/>
                <StackNavigator.Screen name={"Reglage"} component={ReglageScreen}/>
                <StackNavigator.Screen name={"editProfil"} component={EditProfilScreen}/>
                <StackNavigator.Screen name={"Apparence"}  component={ReglageApparenceScreen}/>
                <StackNavigator.Screen name={"Langue"}  component={ReglageLangScreen}/>
                <StackNavigator.Screen name={"Confidentialite"}  component={ReglageConfidentialiteScreen}/>
                <StackNavigator.Screen name={"SWCache"}  component={ReglageCacheScreen}/>
                <StackNavigator.Screen name={"SWNotif"}  component={ReglageNotifScreen}/>
                <StackNavigator.Screen name={"CGU"}  component={ReglageCGU}/>
                <StackNavigator.Screen name={"NIP"} options={{  tabBarVisible:false, headerShown: false}} component={NIPScreen}/>
                <StackNavigator.Screen name={"WebView"} component={WebviewScreen}/>
                <StackNavigator.Screen name={"Connexion"} options={{  tabBarVisible:false, headerShown: false}}  component={ConnexionScreen}/>
                <StackNavigator.Screen name={"MyFocus"} component={FocusScreen}/>
                <StackNavigator.Screen name={"Bookmark"} component={BookmarkScreen}/>
                <StackNavigator.Screen name={"Message"} component={MessengerScreen}/>
            </StackNavigator.Navigator>
        );
    }

    _getExplorerStackNavigator(){
        return (
            <StackNavigator.Navigator>
                <StackNavigator.Screen name={"Explorer"} component={ExplorerScreen}/>
                <StackNavigator.Screen name={"EntityScreen"} getId={({params})=>{return params.type+'-'+params.id}} component={EntityScreen}/>
                <StackNavigator.Screen name={"PostFeed"} getId={({params})=>{params.postId}} component={PostScreen}/>
                <StackNavigator.Screen name={"MyProfil"} options={{headerShown:false}} component={ProfilScreen}/>
                <StackNavigator.Screen name={"Reglage"} component={ReglageScreen}/>
                <StackNavigator.Screen name={"editProfil"}  component={EditProfilScreen}/>
                <StackNavigator.Screen name={"Apparence"} component={ReglageApparenceScreen}/>
                <StackNavigator.Screen name={"Langue"}component={ReglageLangScreen}/>
                <StackNavigator.Screen name={"Confidentialite"} component={ReglageConfidentialiteScreen}/>
                <StackNavigator.Screen name={"SWCache"}  component={ReglageCacheScreen}/>
                <StackNavigator.Screen name={"SWNotif"}  component={ReglageNotifScreen}/>
                <StackNavigator.Screen name={"CGU"}  component={ReglageCGU}/>
                <StackNavigator.Screen name={"NIP"} options={{   tabBarVisible:false, headerShown: false}} component={NIPScreen}/>
                <StackNavigator.Screen name={"WebView"} component={WebviewScreen}/>
                <StackNavigator.Screen name={"Connexion"} options={{  tabBarVisible:false, headerShown: false}}  component={ConnexionScreen}/>
                <StackNavigator.Screen name={"MyFocus"} component={FocusScreen}/>
                <StackNavigator.Screen name={"Bookmark"} component={BookmarkScreen}/>
                <StackNavigator.Screen name={"Message"} component={MessengerScreen}/>
            </StackNavigator.Navigator>
        );
    }

    _getMessengerStackNavigator(){
        return (
            <StackNavigator.Navigator>
                <StackNavigator.Screen name={"Messenger"} component={MessengerScreen}/>
            </StackNavigator.Navigator>
        );
    }


   _handleAppStateChange = nextAppState => {
       if (
            this.state.appState.match(/inactive|background/) &&
            nextAppState === "active"
        ) {
            // const action = {'type': 'SIGN_OUT_NIP', 'value':{}};
            // this.props.dispatch(action);

	    // try to see if there is something new everytime we are back online
	    // this will be catched then when user goes to home screen
	    swRegistrationUpdate();
        }

        this.setState({ appState: nextAppState });
    };

    _stackNavigatorConnected(){
        const styles = StyleSheet.create({
            footerPicto : {
                width:20,
                tintColor:"red",
            },
            badge:{
                position:"absolute",
                right:-5,
                top:1.5,
                backgroundColor:"#F24986",
                opacity:1,
                zIndex:9,
                borderRadius:100,
                width:18,
                height:18,
                alignItems:"center",
                justifyContent:"center",
                padding:5
            },
            badgeText :{
                color : "#fff",
                fontSize:11,
                fontFamily : this.props.theme.fonts.text,
            }
        });
        const prefix = Linking.makeUrl("app");
        const p = "app";
        const linking ={
            prefix:[prefix],
            config:{
                screens:{
                    HomeStack :{
                        path:"/app",
                        initialRouteName:"Home",
                        screens: {
                            Home:"home",
                            MyProfil:{
                                path :"profil/",
                                parser:{
                                },
                                stringify:{
                                }
                            },
                            PostFeed:{
                                path:"post/:postId/",
                                parse: {
                                    id: (postId) => `${postId}`,
                                },
                            },
                            EntityScreen : {
                                path:":type/:id/",
                                parse:{
                                    type: (type)=>`${type}`,
                                    id : (id)=>`${id}`,
                                },
                                stringify: {
                                    item: (item) => "",
                                },
                            },
                            Bookmark : "signet",
                            MyFocus: "my-focus",
                            Reglage:"settings",
                            Apparence:"/settings/apparence",
                            Langue:"/settings/langue",
                            Confidentialite:"/settings/Confidentialite",
                            editProfil:"/settings/edit"
                        }
                    },
                    TendanceStack:{
                        path:"/app/tendance",
                        screens:{
                            tendance:"",
                            MyProfil:"profil",
                            TendancePostFeed:{
                                path : "feed/:type/:id/",
                                parse:{
                                    type: (type)=>`${type}`,
                                    id : (id)=>`${id}`,
                                },
                                stringify: {
                                },
                            },
                            PostFeed:{
                                path:"post/:postId/",
                                parse: {
                                    id: (postId) => `${postId}`,
                                },
                                stringify: {
                                },
                            },
                            EntityScreen : {
                                path:":type/:id/",
                                parse:{
                                    type: (type)=>`${type}`,
                                    id : (id)=>`${id}`,
                                },
                                stringify: {
                                },
                            },
                            Bookmark : "signet",
                            MyFocus: "my-focus",
                            Reglage:"settings",
                            Apparence:"/settings/apparence",
                            Langue:"/settings/langue",
                            Confidentialite:"/settings/Confidentialite",
                            editProfil:"/settings/edit"
                        }
                    },
                    ExplorerStack:{
                        path:"/app/explorer",
                        screens:{
                           Explorer: "",
                            PostFeed:{
                                path:"post/:postId/",
                                parse: {
                                    id: (postId) => `${postId}`,
                                },
                                stringify: {
                                },
                            },
                            EntityScreen : {
                                path:":type/:id/",
                                parse:{
                                    type: (type)=>`${type}`,
                                    id : (id)=>`${id}`,
                               },
                                stringify: {
                                },
                            },
                            MyProfil:"profil",
                            Bookmark : "signet",
                            MyFocus: "my-focus",
                            Reglage:"settings",
                            Apparence:"/settings/apparence",
                            Langue:"/settings/langue",
                            Confidentialite:"/settings/Confidentialite",
                            editProfil:"/settings/edit"
                        }
                    },
                    MessageStack:{
                        path:'/app/message',
                        initialRouteName: 'Messenger',
                        screens:{
                            Messenger:{
                                path:""
                            }
                        }
                    }
                }
            }
        };

        const wrap = (cb) => (icon) => {
          const Elem = cb(icon);
          return <Elem isHeader={true} style={styles.footerPicto} />
        }

        const homestack_icon = wrap((icon) => icon.focused ? FooterAccueilActivePicto : FooterAccueilPicto);
        const tendancestack_icon = wrap((icon) => icon.focused ? FooterTendanceActivePicto : FooterTendancePicto);
        const explorerstack_icon = wrap((icon) => icon.focused ? FooterRechercheActivePicto : FooterRecherchePicto);

        const notification = this.props.notification.notification;
        const message_badge = notification && <View style={styles.badge}><Text style={styles.badgeText}>{/* nb_message */ }</Text></View>;

        const message_icon = (icon) => (
          <View>
            { message_badge }
            { icon.focused
              ? <FooterMessageActivePicto isHeader={true} style={[styles.footerPicto,{width: 21}]} />
              : <FooterMessagePicto isHeader={true} style={[styles.footerPicto,{width: 21}]} />
            }
          </View>
        );

        const tabs = [
            { name: "HomeStack", component: this._getHomeStackNavigator, options: {tabBarIcon: homestack_icon } },
            { name: "TendanceStack", component: this._getTendanceStackNavigator, options: {tabBarIcon: tendancestack_icon} },
            { name: "ExplorerStack", component: this._getExplorerStackNavigator, options: {tabBarIcon: explorerstack_icon } },
            { name: "MessageStack", component: this._getMessengerStackNavigator, options: {tabBarIcon: message_icon } }
         ];

        const tabBarOptions={
          showLabel: false,
          style: {height: 75, borderTopWidth: 1, borderTopColor: this.props.theme.colors.tertiary.black13.value, width: "100%", justifyContent: "center"}
        };

        const setTabBar = (route)=>{
                if(route!=undefined){
                    let index = route.index || 0;
                    let routeName=route.routes[index].name || -1;
                    return (routeName!="NIP" && routeName!="Connexion")
                }
                return true;
            };

        return (
            <NavigationContainer linking={linking} {...getNavigationContainerOpt(this.props)}>
              <StatusBar
                backgroundColor={this.props.theme.colors.primary.White.value}
                barStyle={this.props.isDark ? 'light-content' : 'dark-content'}
                hidden={false} translucent={true} />

              <Tab.Navigator initialRouteName={"HomeStack"} tabBarOptions={tabBarOptions}>
                  <Tab.Screen name={"HomeStack"}
                              options={(navigation)=> ({tabStyle: {display: "none"}, tabBarIcon: homestack_icon, tabBarVisible: setTabBar(navigation.route.state), unmountOnBlur: true})}
                              component={this._getHomeStackNavigator}/>
                  <Tab.Screen name={"TendanceStack"}
                              options={navigation => ({tabBarIcon: tendancestack_icon, unmountOnBlur: true})}
                              component={this._getTendanceStackNavigator}/>
                  <Tab.Screen name={"ExplorerStack"}
                              options={navigation => ({tabBarIcon: explorerstack_icon, unmountOnBlur: true})}
                              component={this._getExplorerStackNavigator}/>
                  <Tab.Screen name={"MessageStack"}
                              options={navigation => ({tabBarIcon: message_icon, unmountOnBlur: true})}
                              component={this._getMessengerStackNavigator}/>
                {/* tabs.map((x, i) => <Tab.Screen key={i} name={x.name} options={navigation=>(x.options)} component={x.component}/>) */}
              </Tab.Navigator>

          </NavigationContainer>
        )
    }

    _stackNavigatorNIP(){
        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            elevation: 0,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;
        // HERE
        return (
            <NavigationContainer {...getNavigationContainerOpt(this.props)}>
                <StatusBar backgroundColor={this.props.theme.colors.primary.White.value} barStyle = {this.props.isDark ? 'light-content' : 'dark-content'} hidden = {false}  translucent = {true}></StatusBar>
                <StackNavigator.Navigator>
                    <StackNavigator.Screen name={"NIP"} component={NIPScreen}
                                           options={{tabBarVisible:false, headerStyle: styleHeaderGlobal, headerShown: false}} />
                </StackNavigator.Navigator>
            </NavigationContainer>
        )
    }

    _stackNavigatorSwUpdate(){
        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            elevation: 0,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;
        // HERE
        return (
            <NavigationContainer {...getNavigationContainerOpt(this.props)}>
                <StatusBar backgroundColor={this.props.theme.colors.primary.White.value} barStyle = {this.props.isDark ? 'light-content' : 'dark-content'} hidden = {false}  translucent = {true}></StatusBar>
                <StackNavigator.Navigator>
                    <StackNavigator.Screen name={"Update"} component={UpdateScreen}
                                           options={{tabBarVisible:false, headerStyle: styleHeaderGlobal, headerShown: false}} />
                </StackNavigator.Navigator>
            </NavigationContainer>
        )
    }


    _stackNavigatorDisconnected(){
        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            elevation: 0,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;
        return (
            <NavigationContainer {...getNavigationContainerOpt(this.props)}>
                    <StatusBar backgroundColor={this.props.theme.colors.primary.White.value} barStyle = {this.props.isDark ? 'light-content' : 'dark-content'} hidden = {false}  translucent = {true} />
                    <StackNavigator.Navigator>
                        <StackNavigator.Screen name={"Connexion"} options={{headerStyle: styleHeaderGlobal, headerShown: false}} component={ConnexionScreen}/>
                    </StackNavigator.Navigator>
            </NavigationContainer>
        )
    }

    render() {
      console.log("[NAV] rendering main navigation")
      // if (! this.state.initialized) {
      //   console.log("[NAV] not initialized");
      //   return this._stackNavigatorDisconnected()
      // }

      if (this.props.auth.compte == null) {
	console.log("[NAV] no account");
        return this._stackNavigatorDisconnected()
      }

      // NIP: deactivate
      if (false && this.props.tokenNIP == null) {
        // [sw] check for update when a NIP is asked when we reach it
        return this._stackNavigatorNIP()
      }

      // If a new application update appears, bring the SW update page
      // dont || because we don't know where we are
      // if (!navigator.serviceWorker?.controller && updateFound()) {
      if (updateFound()) {
	console.log("[NAV] updateFound");
        return this._stackNavigatorSwUpdate();
      }

      // needed if we didn't have time to validate (SW was reloaded)
      // other place is:
      // - first controller
      // - controller changed
      // - SW updated
      const current_registration = getSwRegistration();
      current_registration && ensureSubscribe(current_registration);


      // when user has effectively logged in, connect instant messaging
      console.log("this.props.auth.compte",this.props.auth.compte);
      importConverseJS(this.props.auth.compte);

      return this._stackNavigatorConnected();
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme,token : state.AuthReducer.token,tokenNIP : state.AuthReducer.tokenNIP,auth : state.AuthReducer,notification :state.notificationReducer, online: state.sw_reducer.online};
}


export default connect(mapStateToProps)(NavigationStack);
